const SCROLL_DELAY_MS = 300;

/** Scrolls the first invalid field into view (`data-testid` or `data-field`). */
export function scrollToFirstErrorField(scrollTarget?: string): void {
  if (!scrollTarget) return;
  setTimeout(() => {
    const el = document.querySelector(
      `[data-testid="${scrollTarget}"], [data-field="${scrollTarget}"]`
    );
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, SCROLL_DELAY_MS);
}

/** Collects dot-paths (e.g. `weeks.0.days.1.products`) for each nested error object that has a `message`. */
export function collectNestedFormErrorPaths(
  errors: Record<string, unknown>,
  prefix = ''
): string[] {
  const paths: string[] = [];
  for (const [key, value] of Object.entries(errors)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && 'message' in value) {
      paths.push(path);
    } else if (value && typeof value === 'object') {
      paths.push(
        ...collectNestedFormErrorPaths(value as Record<string, unknown>, path)
      );
    }
  }
  return paths;
}
